<template>
 <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document" :class="modalSize" :style="modalStyle">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="close()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title text-primary"><i class="fa fa-clone" aria-hidden="true"></i>&nbsp;{{title}}</h4>
        </div>
		<slot name="body"></slot>
        <div class="modal-footer" style="text-align: center;">
			 <slot name="footer"></slot>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>
<script>
/**
 * 组件名称：模态弹出框
 */
import $ from 'jquery';
export default {
    name:"BootstrapDialog",
    props:{
		title: {//标题
            type:String,
            required:true
        },
		modalStyle:{
			type:Object,
			default(){
				return {};
			}
		},
		size: {//尺寸   可选值 ：sm lg
		    type:String,
		    default(){
				return "";
			}
		},
    },
    data:function(){
        return {
            
        }
    },
	computed:{
		modalSize:function(){
			let size = this.size || '';
			if(size){
				size = 'modal-'+this.size;
			}
			return size;
		}
	},
    methods:{
		open:function(){
			let _this = this;
			_this.$emit('beforeOpen');
			_this.$nextTick(()=>{
				$(_this.$el).modal('show');
			});
			$(_this.$el).on('shown.bs.modal', function (e) {
			  _this.$emit('afterOpen');
			});
		},
		close:function(){
			let _this = this;
			_this.$emit('beforeClose');
			$(_this.$el).modal('hide');
			$(_this.$el).on('hidden.bs.modal', function (e) {
			  _this.$emit('afterClose');
			});
		}
    }
}
</script>